import { formatPropertyLocation } from '~/components/Offers/Detail/OfferBuilder/Content/PropertyInformation';

import { type BuildDetailsFieldsParams, field, selectField, typedField, withLayout } from '../fieldHelpers';
import type { DetailField } from '../types';

type PartnershipGoalsWithHeroShot = App.PartnershipGoals & {
  hero_shot_link__c?: string;
};

export function buildPropertyInfoFields({ opportunity, property }: BuildDetailsFieldsParams): Array<DetailField> {
  const partnershipGoals = opportunity?.partnership_goals as PartnershipGoalsWithHeroShot | undefined;

  return [
    withLayout(
      field(
        'USP',
        partnershipGoals?.usp__c,
        'Sell us the deal! What is the core USP? Give us MORE detail not less.',
        true,
      ),
      { columns: 1 },
    ),
    withLayout(field('#1 Selling Point', undefined, 'What is the single most unique selling point and why?', true), {
      columns: 2,
    }),
    withLayout(field('Customer Experience Notes', undefined, 'Customer experience notes for the property.', true), {
      columns: 2,
    }),
    selectField(
      'Holiday Vibe',
      undefined,
      [
        'CBD Staycation',
        'Beach Getaway',
        'Mountain Retreat',
        '5-star luxury',
        'Stylish stopover',
        'Unique experience',
        'Romantic',
        'Family fun',
        'Foodie',
      ],
      'What is the holiday vibe?',
      { columns: 2 },
    ),
    selectField(
      'Target Selling Market',
      undefined,
      ['Couples', 'Families', 'Solo Travelers', 'Groups', 'Other'],
      'Who is this campaign targeting?',
      {
        columns: 2,
      },
    ),
    withLayout(field('Check-in/out time', undefined, 'Check-in and check-out times'), { columns: 2 }),
    withLayout(field('Hotel Age', undefined, 'Year the hotel opened'), { columns: 2 }),
    withLayout(field('Hotel Last Renovation', undefined, 'Year of last renovation'), { columns: 2 }),
    withLayout(field('Closest Airport', undefined, 'Closest major airport'), { columns: 2 }),
    withLayout(field('Airport Transfer Cost', undefined, 'Approximate transfer cost'), { columns: 2 }),
    withLayout(field('Distance to the Beach', undefined, 'Distance to nearest beach'), { columns: 2 }),
    withLayout(field('Location Attractions', formatPropertyLocation(property), 'Nearby attractions', true), {
      columns: 2,
    }),
    withLayout(field('Other Key Benefits', undefined, 'List any other key benefits or amenities.', true), {
      columns: 2,
    }),
    withLayout(field('Disability Access', undefined, 'Disability access info'), { columns: 2 }),
    withLayout(field('Rooms with Wheelchair access', undefined, 'Number of wheelchair-accessible rooms'), {
      columns: 2,
    }),
    withLayout(field('Smoking Policy', undefined, 'Property smoking policy'), { columns: 2 }),
    withLayout(field('Parking', undefined, 'Parking availability and cost'), { columns: 2 }),
    withLayout(field('Wi-fi', undefined, 'Wi-fi availability'), { columns: 2 }),
    withLayout(field('Recent Awards/Accolades', undefined), { columns: 2 }),
    withLayout(field('Babysitting', undefined, 'Babysitting services'), { columns: 2 }),
    withLayout(field('Kids Club', undefined, 'Kids club availability'), { columns: 2 }),
    withLayout(field('Shop Onsite', undefined, 'On-site shops'), { columns: 2 }),
    withLayout(field('Shops and restaurants Nearby', undefined, 'Nearby shops and restaurants'), { columns: 2 }),
    withLayout(
      field(
        'Gala Dinner & Other Functions Policies',
        undefined,
        'Gala Dinner & Other Functions Policies information for internal use, does not populate contract.',
        true,
      ),
      { columns: 1 },
    ),
    withLayout(
      field(
        'Deal Copy/Image Notes',
        undefined,
        'Use this field for any Copy/Editorial/Image Specific Notes For Luxury Escapes - Comments Section.',
        true,
      ),
      { columns: 2 },
    ),
    typedField('Hero Shot Link', partnershipGoals?.hero_shot_link__c, 'url', undefined, {
      columns: 2,
    }),
  ];
}
